import { stationMatchesBrand } from "./brands.js";

export const SORTS = ["best", "cheapest", "closest"];

export function sortLabel(sort, tripMode) {
  if (sort === "cheapest") return "Más barata";
  if (sort === "closest") return tripMode === "enRoute" ? "Menos desvío" : "Más cercana";
  return "Mejor opción";
}

function normalized(value) {
  return String(value || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLocaleLowerCase("es");
}

export function matchesQuery(station, query) {
  const needle = normalized(query).trim();
  return !needle || normalized(`${station.name} ${station.brand || ""} ${station.address}`).includes(needle);
}

export function searchStations(stationsWithinRadius, brandFilter, query) {
  return stationsWithinRadius.filter((station) => stationMatchesBrand(station, brandFilter) && matchesQuery(station, query));
}

// Las estaciones llegan ordenadas por precio real; las otras dos ordenaciones
// desempatan por precio real para que el orden sea estable.
export function sortStations(stations, sort, tripMode = "roundTrip") {
  const list = [...stations];
  const byReal = (left, right) => left.estimate.effectivePrice - right.estimate.effectivePrice;
  if (sort === "cheapest") return list.sort((left, right) => left.pumpPrice - right.pumpPrice || byReal(left, right));
  if (sort === "closest") {
    const distance = (station) => (tripMode === "enRoute" ? station.estimate.travelKm : station.estimate.oneWayRoadKm);
    return list.sort((left, right) => distance(left) - distance(right) || byReal(left, right));
  }
  return list.sort(byReal);
}
